import { IState } from 'legacy/lut/store'

export const selectFinancialCockpitState = (state: IState) => state.partner360.financialCockpit
